export enum OrderTypesEnum {
  IN_STORE = 1,
  DELIVERY = 2,
  PICKUP = 3,
}
